module.exports = __webpack_public_path__ + "img/startup-bg-blue.531ddb14.jpg";